import { TApplicationState } from '../../types/redux';

export const consultantChatIdSelector = (state: TApplicationState) => state.consultantCianChat.chatId;
